import axios from "axios";

export const apiClient = axios.create({
    baseURL: "https://sprintbe.globsolutions.in",
    //baseURL: "http://localhost:8080",
});
